import { FunctionComponent, useContext } from "react";
import { useStateIfMounted } from "use-state-if-mounted";
import {
  ROUTE_PUBLIC_FORGOT_PASSWORD,
  ROUTE_PUBLIC_ROOT,
  ROUTE_PUBLIC_SIGN_UP,
} from "../../shared/app-constants";
import getErrorMessage from "../../shared/get-error-msg";
import { LocalStorageManager } from "../../shared/local-storage-manager";
import { LoginData } from "../../shared/login-data";
import LoginForm from "../../shared/login-form";
import { AppContext } from "../contexts/app-context";
import HttpClient from "../http-client";

interface SignInPageProps {}

const SignInPage: FunctionComponent<SignInPageProps> = () => {
  const [busy, setBusy] = useStateIfMounted(false);
  const [serverMsg, setServerMsg] = useStateIfMounted<string | undefined>(
    undefined
  );
  const [serverMsgType, setServerMsgType] = useStateIfMounted<
    "error" | "success" | undefined
  >(undefined);
  const { setUser } = useContext(AppContext);

  const login = async (userData: LoginData) => {
    setBusy(true);
    setServerMsg(undefined);
    try {
      const { data } = await HttpClient.post("user/sign-in", userData);
      if (data?.data?.access_token) {
        const { access_token, refresh_token } = data.data;
        LocalStorageManager.saveTokens(access_token, refresh_token);
        setServerMsgType("success");
        setServerMsg("You are successfully logged in!");
        setUser(data.data);
      }
    } catch (error: any) {
      if (error?.response?.data?.error) {
        setServerMsgType("error");
        setServerMsg(getErrorMessage(error?.response?.data));
      }
    }
    setBusy(false);
  };
  return (
    <div className="form-container">
      <LoginForm
        registrationRoute={[ROUTE_PUBLIC_ROOT, ROUTE_PUBLIC_SIGN_UP].join("/")}
        forgotPasswordRoute={[
          ROUTE_PUBLIC_ROOT,
          ROUTE_PUBLIC_FORGOT_PASSWORD,
        ].join("/")}
        onSubmit={login}
        busy={busy}
        serverMsg={serverMsg}
        serverMsgType={serverMsgType}
      />
    </div>
  );
};

export default SignInPage;
